import { isFaqItemOpen, setFaqItemOpen } from "./_faqAccordion";

const SELECTORS = {
  FAQ_ITEM: "faq__item",
  FAQ_ITEM_LABEL: "faq__item-label",
};

export class FaqToggle {
  constructor() {
    this.items = document.querySelectorAll(`.${SELECTORS.FAQ_ITEM}`);
    this.init();
  }

  init() {
    this.items.forEach((item) => {
      const label = item.querySelector(`.${SELECTORS.FAQ_ITEM_LABEL}`);
      label?.addEventListener("click", () => this.toggleItem(item));
    });
  }

  toggleItem(currentItem) {
    const shouldOpen = !isFaqItemOpen(currentItem);

    // Одновременно может быть открыт только один пункт
    if (shouldOpen) {
      this.items.forEach((item) => {
        if (item !== currentItem) {
          setFaqItemOpen(item, false);
        }
      });
    }

    setFaqItemOpen(currentItem, shouldOpen);
  }
}

// Инициализация при загрузке DOM
document.addEventListener("DOMContentLoaded", function () {
  new FaqToggle();
});
